import * as React from "react";
const SvgFiRrPrintSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-print-slash_svg__a)">
      <path
        fill="#062147"
        d="M24 16v-5c0-2.757-2.243-5-5-5V4c0-2.206-1.794-4-4-4H9a4.005 4.005 0 0 0-3.98 3.605L1.706.293A.999.999 0 1 0 .293 1.707l22 22a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-2.053-2.053A5 5 0 0 0 24 16M7 4c0-1.103.897-2 2-2h6c1.103 0 2 .897 2 2v2H7.414L7 5.586zm15 12a3 3 0 0 1-1.825 2.761L9.415 8.001H19c1.654 0 3 1.345 3 3zm-3-5a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1m-1.134 11.232a1 1 0 0 1-.366 1.366A3 3 0 0 1 16 24H8c-1.654 0-3-1.346-3-3-2.757 0-5-2.243-5-5v-5a5 5 0 0 1 1.693-3.75 1 1 0 0 1 1.322 1.5A3 3 0 0 0 2 11v5c0 1.654 1.346 3 3 3v-2c0-1.654 1.346-3 3-3h1a1 1 0 1 1 0 2H8a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h8c.176 0 .35-.046.5-.134a1 1 0 0 1 1.366.366z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-print-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPrintSlash;
